export const colors = {
  primary: "#763ff9", // from --color-primary-500
  primary50: "#f1ecfe",
  primary100: "#e4d9fe",
  primary200: "#ba9ffc",
  primary600: "#5e32c7",
  primary700: "#472695",
  primary800: "#2F1964",
  neutral100: "#f8f9fb",
  neutral150: "#f4f6f9",
  neutral200: "#f0f2f7",
  neutral300: "#eaedf4",
  neutral500: "#e1e6f0",
  neutral600: "#cdd4df",
  neutral800: "#8f9baa",
  neutral900: "#627183",
  red50: "#ffe6f1",
  green50: "#e6fcf6",
  green100: "#ccf8ed",
  green400: "#34e4b7",
  green500: "#01dda5",
  green700: "#018563",
  green800: "#015842",
  pink100: "#ffcce3",
  pink400: "#ff3490",
  pink500: "#ff0174",
  pink600: "#cc015d",
  orange500: "#ff5319",
  brands: {
    whatsapp: "#1BD741",
  },
};
